/**
 * Shopify Admin discount flag on product page only.
 * Never changes price. Shows "Save X%" when THIS product line is discounted.
 */
(function () {
  'use strict';

  var ROOT =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = Object.create(null);
  var busy = false;

  function getRoot() {
    return document.querySelector(
      '.xo-product-info-content [data-admin-discount-root][data-variant-id]'
    );
  }

  function showFlag(el, percent) {
    if (!el) return;
    percent = Math.round(Number(percent) || 0);
    el.setAttribute('data-discount-percent', String(percent));
    if (percent <= 0) {
      el.textContent = '';
      el.classList.remove('is-visible');
      el.setAttribute('data-admin-discount-status', 'none');
      el.style.display = 'none';
      return;
    }
    el.textContent = 'Save ' + percent + '%';
    el.classList.add('is-visible');
    el.setAttribute('data-admin-discount-status', 'applied');
    el.style.display = 'inline-flex';
  }

  function percentFromLine(line) {
    if (!line) return 0;
    var original = Number(line.original_price != null ? line.original_price : line.price);
    var finalPrice = Number(
      line.final_price != null
        ? line.final_price
        : line.discounted_price != null
          ? line.discounted_price
          : line.price
    );
    var qty = Number(line.quantity || 1);
    var originalLine = Number(
      line.original_line_price != null ? line.original_line_price : original * qty
    );
    var finalLine = Number(
      line.final_line_price != null
        ? line.final_line_price
        : line.line_price != null
          ? line.line_price
          : finalPrice * qty
    );

    if (line.line_level_discount_allocations && line.line_level_discount_allocations.length) {
      for (var i = 0; i < line.line_level_discount_allocations.length; i++) {
        var app = line.line_level_discount_allocations[i].discount_application;
        if (app && String(app.value_type || '').toLowerCase() === 'percentage') {
          var pct = parseFloat(app.value);
          if (pct > 0) return Math.round(pct);
        }
      }
      var alloc = line.line_level_discount_allocations.reduce(function (sum, a) {
        return sum + Number(a.amount || 0);
      }, 0);
      if (alloc > 0 && originalLine > 0) return Math.round((alloc / originalLine) * 100);
    }

    if (Number(line.total_discount) > 0 && originalLine > 0) {
      return Math.round((Number(line.total_discount) / originalLine) * 100);
    }
    if (finalLine < originalLine && originalLine > 0) {
      return Math.round(((originalLine - finalLine) / originalLine) * 100);
    }
    if (finalPrice < original && original > 0) {
      return Math.round(((original - finalPrice) / original) * 100);
    }
    return 0;
  }

  function fetchJson(url, options) {
    options = options || {};
    options.credentials = 'same-origin';
    options.headers = Object.assign(
      { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      options.headers || {}
    );
    return fetch(url, options).then(function (res) {
      return res.text().then(function (text) {
        var t = (text || '').trim();
        if (!t || t.charAt(0) === '<') {
          if (!res.ok) throw new Error(url + ' ' + res.status);
          return null;
        }
        var data = null;
        try {
          data = JSON.parse(t);
        } catch (e) {
          if (!res.ok) throw new Error(url + ' ' + res.status);
          return null;
        }
        if (!res.ok) {
          throw new Error(
            (data && (data.description || data.message)) || url + ' ' + res.status
          );
        }
        return data;
      });
    });
  }

  function getCart() {
    return fetchJson(ROOT + 'cart.js');
  }

  function getSelectedVariantId(fallback) {
    var input = document.querySelector(
      '.xo-product-info-content form[action*="/cart/add"] [name="id"]'
    );
    if (input && input.value) return Number(input.value);
    if (window.theme && window.theme.adminDiscount && window.theme.adminDiscount.variantId) {
      return Number(window.theme.adminDiscount.variantId);
    }
    return Number(fallback) || 0;
  }

  function findLine(cart, variantId) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (Number(cart.items[i].variant_id) === Number(variantId)) return cart.items[i];
    }
    return null;
  }

  function restoreCart(beforeKeys) {
    return getCart().then(function (cart) {
      cart = cart || { items: [] };
      var chain = Promise.resolve();
      cart.items.forEach(function (item) {
        if (beforeKeys[item.key] != null) return;
        chain = chain.then(function () {
          return fetchJson(ROOT + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(item.key), quantity: 0 }),
          }).catch(function () {
            return null;
          });
        });
      });
      return chain;
    });
  }

  function probeVariant(variantId) {
    if (!variantId || busy) return Promise.resolve();
    if (cache[variantId] !== undefined) {
      showFlag(getRoot(), cache[variantId]);
      return Promise.resolve();
    }

    busy = true;
    document.documentElement.classList.add('admin-discount-probing');

    return getCart()
      .then(function (before) {
        before = before || { items: [] };
        var existing = findLine(before, variantId);
        if (existing) {
          var pct = percentFromLine(existing);
          cache[variantId] = pct;
          showFlag(getRoot(), pct);
          return null;
        }

        var beforeKeys = {};
        before.items.forEach(function (item) {
          beforeKeys[item.key] = item.quantity;
        });

        function tryQty(qty) {
          return fetchJson(ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: qty }],
            }),
          })
            .then(function () {
              return getCart();
            })
            .then(function (cart) {
              var line = findLine(cart, variantId);
              var pct = percentFromLine(line);
              return restoreCart(beforeKeys).then(function () {
                return pct;
              });
            });
        }

        return tryQty(1).then(function (pct) {
          if (pct > 0) return pct;
          return tryQty(2);
        });
      })
      .then(function (pct) {
        if (pct == null) return;
        cache[variantId] = Math.round(Number(pct) || 0);
        showFlag(getRoot(), cache[variantId]);
      })
      .catch(function (err) {
        console.warn('[admin-discount]', err && err.message ? err.message : err);
        cache[variantId] = 0;
        showFlag(getRoot(), 0);
      })
      .finally(function () {
        busy = false;
        document.documentElement.classList.remove('admin-discount-probing');
      });
  }

  function refresh() {
    var root = getRoot();
    if (!root) return;
    var id = getSelectedVariantId(root.getAttribute('data-variant-id'));
    if (!id) return;
    root.setAttribute('data-variant-id', String(id));
    probeVariant(id);
  }

  function bind() {
    document.addEventListener(
      'change',
      function (event) {
        var t = event.target;
        if (!t) return;
        if (t.name !== 'id' && !t.closest('xo-product-variant')) return;
        var root = getRoot();
        if (!root) return;
        var id = t.name === 'id' && t.value ? Number(t.value) : getSelectedVariantId();
        if (!id) return;
        root.setAttribute('data-variant-id', String(id));
        delete cache[id];
        probeVariant(id);
      },
      true
    );
  }

  function init() {
    if (!getRoot()) return;
    bind();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ProductAdminDiscount = { refresh: refresh, cache: cache };
})();
